"use client";

import React from "react";
import { Gauge, UserCog, Users, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const rightsData = [{
  title: "Access & Portability",
  description: "Request a comprehensive copy of your personal data in a structured, machine-readable format to maintain full control over your information.",
  icon: Gauge
}, {
  title: "Correction & Deletion",
  description: "Easily update inaccurate records or exercise your 'right to be forgotten' by requesting the permanent removal of your data from our systems.",
  icon: UserCog
}, {
  title: "Data Rights & Compliance Requests",
  description: "We adhere to strict international standards, ensuring EU visitors and global users can exercise their rights through a transparent, legal process.",
  icon: Users
}];
export default function UserRights() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261789" id="user-rights" className="bg-[#0B1220] py-14 md:py-18 lg:py-20 min-h-screen flex items-center scroll-mt-[120px] snap-start text-[#F8FAFC] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        <div ref={headerRef} className={`max-w-4xl mx-auto text-center mb-3 md:mb-4 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6 text-[#F8FAFC]">
            User Rights & Data Control
          </h2>
          <p className="text-base md:text-lg text-[#CBD5E1] font-sans max-w-3xl mx-auto leading-relaxed">
            FETC maintains transparent data practices, providing users with the necessary tools to access, manage, and oversee their personal information in accordance with global data protection standards.
          </p>
        </div>

        <div ref={contentRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {rightsData.map((item, index) => <Card key={index} data-index={index} className="bg-[#142033] border-[rgba(19,184,200,0.18)] text-[#F8FAFC] shadow-lg hover:border-[#13B8C8]/40 transition-all duration-300">
              <CardHeader className="flex flex-col items-start gap-2">
                <div className="p-3 bg-[#13B8C8]/10 rounded-lg text-[#13B8C8]">
                  <item.icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <CardTitle className="text-xl font-bold font-default text-[#F8FAFC]">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pb-6">
                <p className="text-[#CBD5E1] font-sans leading-relaxed text-sm md:text-base">
                  {item.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 md:mt-20 text-center">
          <Link to="/ContactUsPage">
            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium bg-[#0F62FE] hover:bg-[#0043CE] text-white font-sans text-base px-8 h-12 rounded-lg shadow-md transition-all duration-300 cursor-pointer">
              Exercise Your Rights
            </button>
          </Link>
          
          <div className="mt-8 flex items-center justify-center gap-3 text-sm font-medium text-[#CBD5E1]/60">
            <CircleCheck className="w-5 h-5 text-[#13B8C8]" />
            <span className="font-sans">Aligned with global data protection regulations.</span>
          </div>
        </div>

      </div>
    </section>;
}